export default "__VITE_ASSET__CzZwMd6U__"